export default {"src":"/_next/static/media/0xb20bd5d04be54f870d5c0d3ca85d82b34b836405.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};